// https://railsdesigner.com/modal-with-rails-hotwire/

import { Controller } from "@hotwired/stimulus";
import { createFocusTrap, FocusTrap } from "../common/focus_trap";

export default class extends Controller {
  private trap: FocusTrap;

  connect(): void {
    const element = this.element as HTMLElement;

    this.trap = createFocusTrap(element, {
      clickOutsideDeactivates: false,
      escapeDeactivates: false,
      fallbackFocus: element,
      initialFocus: element,
    });

    this.trap.activate();
    element.focus();
  }

  disconnect(): void {
    if (this.trap) {
      this.trap.deactivate();
      this.trap = null;
    }
  }

  closeModal(event: Event): void {
    event.preventDefault();
    const element = this.element as HTMLElement;
    if (this.trap) {
      this.trap.deactivate();
      this.trap = null;
    }
    element.remove();
  }
}
